import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bulkActions", "singularActions", "control", "checkbox", "fieldset"]
  static outlets = ["navbar"]
  static classes = ["hidden"]
  static values = { totalRecordCount: Number }

  connect() {
    this.#toggleTargets()
  }

  submit(event) {
    const count = this.checkboxTargets.filter(cb => cb.checked).length

    if (count === 0) {
      event.preventDefault()
      return
    }

    const confirmed = window.confirm(
      `You are about to perform the operation on ${count} out of ${this.totalRecordCountValue} records. Are you sure?`
    )

    if (!confirmed) {
      event.preventDefault()
    }

    const formId = event.target.form.id

    if (formId) {
      // Link the checkboxes to the form if they are placed outside the form tag.
      this.checkboxTargets.forEach(cb => {
        cb.setAttribute("form", formId)
      })
    }
  }

  select(event) {
    event.preventDefault()

    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = event.params.scope === "all"
    })

    this.#toggleTargets()
  }

  clearSelection(event) {
    event.preventDefault()

    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = false
    })

    this.#toggleTargets()
  }

  selectOne() {
    this.#toggleTargets()
  }

  #toggleTargets() {
    const anyChecked = this.checkboxTargets.some(checkbox => checkbox.checked)

    this.singularActionsTargets.forEach(element => {
      element.classList.toggle(this.hiddenClass, anyChecked)
    })

    if (this.hasBulkActionsTarget) {
      const bulkActions = this.bulkActionsTarget
      bulkActions.classList.toggle("collapse", !anyChecked)

      if (anyChecked) {
        const fieldset = this.fieldsetTarget
        const navbar = this.navbarOutlet.element
        const navbarHeight = navbar.getBoundingClientRect().height
        const topMargin = parseInt(getComputedStyle(fieldset).marginTop, 10) // remove "px"
        fieldset.style.top = `${navbarHeight + topMargin}px`
      }
    }

    this.controlTargets.forEach(control => {
      control.classList.toggle("disabled", !anyChecked)
      control.disabled = !anyChecked
    })
  }
}
